import * as React from 'react';

import styles from './AreaLink.css';

interface IAreaLinkProps {
  href: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  className?: string;
  children: React.ReactNode;
}

export const AreaLink: React.FC<IAreaLinkProps> = ({ href, onClick, className, children }) => {
  const combinedClassName = className ? `${styles['link']} ${className}` : styles['link'];

  return (
    <a className={combinedClassName} href={href} target="_blank" rel="noreferrer" onClick={onClick}>
      {children}
    </a>
  );
};

AreaLink.displayName = 'AreaLink';
